import React from 'react';
import { Link } from 'react-router-dom'
import {
    ApartmentOutlined,
    DashboardOutlined,
    DesktopOutlined,
    PieChartOutlined,
    ShareAltOutlined,
} from '@ant-design/icons';
import { Avatar, Skeleton } from 'antd';
import { Menu } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { useLocation } from 'react-router-dom';

import type {MenuProps} from 'antd';

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group'
): MenuItem {
    return {
        key,
        icon,
        children,
        label,
        type,
    } as MenuItem;
}

const items: MenuProps['items'] = [
    getItem(<><Link to="/dashboard">Dashboard</Link></>, '1', <DashboardOutlined />),
    getItem(<><Link to="/devices">Devices</Link></>, '2', <ApartmentOutlined />),
    getItem(<><Link to="/clients">Client</Link></>, '3', <DesktopOutlined />),
    getItem(<><Link to="/applications">Applications</Link></>, '4', <PieChartOutlined />),
    getItem("Networks", 'sub1', <ShareAltOutlined />, [
        getItem(<><Link to="/networks-configuration">Network configuration</Link></>, '5')
    ])
];


const AuthSider: React.FC = () => {
    let location = useLocation();
    const [menuKey, setMenuKey] = React.useState<string[] | undefined>(['1']);
    // const [openKey, setOpenKey] = React.useState<string[] | undefined>(['sub1']);

    const setMenuKeys = React.useCallback((pathname: string) => {
        switch (pathname) {
            case '/dashboard':
                setMenuKey(['1']);
                break;
            case '/devices':
                setMenuKey(['2']);
                break;
            case '/clients':
                setMenuKey(['3']);
                break;
            case '/applications':
                setMenuKey(['4']);
                break;
            case '/networks-configuration':
                setMenuKey(['5']);
                break;
            default:
        }
    }, []);

    React.useEffect(() => {
        const pathname = location.pathname
        setMenuKeys(pathname);
    }, [location, setMenuKeys])

    return (
        <Sider collapsible style={{ minHeight: '100vh' }} width={250}>
            <div style={{ height: 64, display: 'flex', alignItems: 'center', padding: 15 }}>
                <Link to='/dashboard' >
                    {/* LOGO */}
                    <Skeleton.Node style={{ width: '100%'}}>
                        <Avatar shape='square' size={80} style={{ color: '#FFFFFF', backgroundColor: 'transparent' }}>LOGO</Avatar>
                    </Skeleton.Node>
                </Link>
            </div>
            <Menu
                theme="dark"
                mode="inline"
                selectedKeys={menuKey}  
                // openKeys={openKey}                    
                // defaultSelectedKeys={['1']}
                defaultOpenKeys={['sub1']}          
                items={items}
            />
        </Sider>
    );
}

export default AuthSider;